import React from 'react';
import {PageCover, PortfolioWithLnb,Footer} from 'components/section';
 
const Portfolio = () => {
 return (
  <div className="Portfolio padding-cover">
    <PageCover 
      url="portfolio"
      title = "PORTFOLIO" 
      text = "동구밭 팩토리가 만들어온 생산품을 소개합니다."
    />
    <PortfolioWithLnb />
    <Footer />
  </div>
 );
}

export default Portfolio;